<template>
  <div class="i-star-component" @click.stop="toggleFavorite">
    <font-awesome-icon
      icon="fa-duotone fa-solid fa-star"
      :class="{ favorite: isFavorite, 'not-favorite': !isFavorite }"
    />
  </div>
</template>


<script>
export default {
  name: "IStarComponent",
  props: {
    isFavorite: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    toggleFavorite() {
      this.$emit("toggleFavorite", !this.isFavorite);
    },
  },
};
</script>

<style>
@import "IStarComponent.scss";
</style>
